/**
 * Shared live presence, distinct from event.participants.
 *
 * participants = historical membership (recap, attribution).
 * presence     = whether that uid is currently in the live room.
 *
 * A missing presence doc is treated as online so already-connected clients
 * do not flicker offline before their first presence write.
 */

export const PRESENCE_STATUS = {
  online: 'online',
  offline: 'offline',
};

export function buildPresenceOnline(uid, { lastSeenAt = Date.now() } = {}) {
  if (!uid) return null;
  return {
    uid,
    status: PRESENCE_STATUS.online,
    lastSeenAt,
    leftAt: null,
  };
}

export function buildPresenceOffline(uid, { lastSeenAt = Date.now(), leftAt = lastSeenAt } = {}) {
  if (!uid) return null;
  return {
    uid,
    status: PRESENCE_STATUS.offline,
    lastSeenAt,
    leftAt,
  };
}

export function isPresenceOnline(entry) {
  if (!entry) return true;
  return entry.status === PRESENCE_STATUS.online;
}

export function isParticipantOnline(participantId, presenceByUid) {
  if (!participantId) return false;
  return isPresenceOnline(presenceByUid?.[participantId]);
}

export function countOnlineParticipants(participants, presenceByUid) {
  if (!Array.isArray(participants)) return 0;
  return participants.filter((row) => isParticipantOnline(row?.id, presenceByUid)).length;
}
